export default __webpack_public_path__ + "static/media/new_user.5cb66768.svg";